var map = {
	"./Deep Dive into Hospitality Industry.jpeg": 7663,
	"./Exchange of Ideas.jpeg": 247,
	"./IIHM Group Photo.jpg": 5552,
	"./Pactical Insights about Food & Beverages Industry.jpeg": 3212,
	"./Understanding Hospitality Back end careers.jpeg": 5338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5129;